
import { computed, defineComponent, reactive, ref, toRefs, watch } from 'vue'
import { useRoute } from 'vue-router'
import router from '@/router/index'
import SearchCourse from './search.vue'
import StarTabBar from '@/components/star/StarTabBar.vue'
import { useStore } from 'vuex'
const __default__ = defineComponent({
  components: { SearchCourse, StarTabBar },
  setup() {
    type pageDataType = {
      menulist: any
      selectedKeys?: Array<string>
      theme?: string | undefined
    }
    const route = useRoute()
    const store = useStore()
    const fromStar = computed(() => route.query.starEmbed === '1')
    const starActiveTab = ref('school')
    const pageData: pageDataType = reactive({
      menulist: [],
      selectedKeys: [],
      theme: (route.query.theme as string) || 'light'
    })
    watch(
      () => route.query.theme,
      () => {
        const theme = route.query.theme as string
        pageData.theme = theme || 'light'
      }
    )
    const jfschoolroutes = router.options.routes.filter((item: any) => item.name === 'jfschool')
    pageData.menulist = jfschoolroutes[0].children?.filter((item: any) => !item.meta?.hide)
    function navclick(item: any) {
      const query = JSON.parse(JSON.stringify(route.query))
      delete query.groupCode
      delete query.courseNo
      delete query.groupName
      delete query.lessonNo

      const dom: any = document.querySelector('.jfschool > main')
      dom.scrollTop = 0
      router.push({
        name: item.name,
        query: query
      })
    }
    // 根据 query.from 或 meta.pname 设置选中的 tab
    function getSelectedKey() {
      if (route.query.from) {
        return route.query.from as string
      }
      return (route.meta.pname || route.name) as string
    }
    pageData.selectedKeys = [getSelectedKey()]
    watch(
      () => [route.name, route.query.from],
      () => {
        pageData.selectedKeys = [getSelectedKey()]
      }
    )
    router.beforeEach((to, from, next) => {
      const detailTitle = to.name === 'articledetail' ? '文章详情' : '课程详情'
      if (from.name === 'allcourse') {
        store.commit('setBreadcrumbList', [
          { title: '全部课程', routename: '' },
          { title: detailTitle, routename: '' }
        ])
      } else if (from.name === 'excellentcourse') {
        store.commit('setBreadcrumbList', [
          { title: '精品课程', routename: '' },
          { title: detailTitle, routename: '' }
        ])
      } else if (from.name === 'specialcourse' || from.name === 'selectedtopics') {
        store.commit('setBreadcrumbList', [
          { title: '精选专题', routename: '' },
          { title: detailTitle, routename: '' }
        ])
      }
      next()
    })
    return {
      ...toRefs(pageData),
      navclick,
      fromStar,
      starActiveTab
    }
  }
})

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "b582dde4": (_ctx.fromStar ? 'calc(100% - 85px)' : 'calc(100% - 36px)')
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__